import {DefaultDOMElement} from 'substance'
import {NilUUID} from './NilUUID'
import {authorNodeTrait} from './traits/authorNodeTrait'

const extractAuthors = function(authorLinks) {
    return authorLinks.children
        .filter((authorLinkEl) => authorLinkEl.getAttribute('rel') === 'author')
        .map((authorLinkEl) => {
            const emailElement = authorLinkEl.find('email')
            const uuid = authorLinkEl.getAttribute('uuid')
            const links = authorLinkEl.find('links')
            return {
                uuid,
                name: authorLinkEl.getAttribute('title'),
                email: emailElement ? emailElement.textContent : null,
                links,
                isSimpleAuthor: NilUUID.isNilUUID(uuid),
                isLoaded: false
            }
        })
        .reduce((authors, author) => {
            if (author.isSimpleAuthor || !authors.some((existing) => existing.uuid === author.uuid)) {
                authors.push(author)
            }

            return authors
        }, [])
}

/**
 * Initialize helper function with a proper api
 * so we won't have to provide one when using it
 *
 * @param api
 * @returns {function(*)}
 */
const fetchImageMeta = (api) => {
    /**
     * Actual function used, returns object with image metadata.
     *
     * @param uuid Image UUID
     * @returns object Object containing image metadata
     */
    return (uuid) => {

        const authorHelper = authorNodeTrait(api)

        return api.router.get(`/api/newsitem/${uuid}`, {imType: 'x-im/image'})
            .then(response => api.router.checkForOKStatus(response))
            .then(response => response.text())
            .then((xmlString) => {
                // Create a default DOMElement for the image Newsitem
                const imageNewsItemDocument = DefaultDOMElement.parseXML(xmlString)

                // imageNewsItemDocument might be array of elements with newsitem element first, or just a newsitem element
                const imageNewsItem = Array.isArray(imageNewsItemDocument) ? imageNewsItemDocument[0] : imageNewsItemDocument

                const authorLinks = imageNewsItem.find('itemMeta > links')
                const authors = (authorLinks && authorLinks.children.length > 0) ? extractAuthors(authorLinks) : []

                return Promise.all(
                    authors.map((author) => authorHelper.fetchAuthorConcept(author))
                ).then((authors) => {
                    return {
                        imageNewsItem,
                        authors
                    }
                })
            })
            .then(({imageNewsItem, authors}) => {
                // Find the object element in the newsitem
                const width = imageNewsItem.find('contentMeta > metadata > object > data > width')
                const height = imageNewsItem.find('contentMeta > metadata > object > data > height')
                const text = imageNewsItem.find('contentMeta > metadata > object > data > text')
                const uuid = imageNewsItem.attr('guid')
                const credit = imageNewsItem.find('contentMeta > metadata > object > data > credit')

                return {
                    uri: imageNewsItem.find('itemMetaExtProperty[type="imext:uri"]').attr('value'),
                    width: Number(width.textContent),
                    height: Number(height.textContent),
                    caption: text ? text.textContent : '',
                    credit: credit ? credit.textContent : '',
                    uuid,
                    authors
                }
            })
    }
}

export {fetchImageMeta}
